import { IMAGE_COMING_SOON } from '~/core/constants';
import { ApplianceModel } from '~/core/models';

// TODO: check the possibility of having an 'Image' component that handles
// the 'COMING_SOON_IMAGE' instead
export const addMockImage = (appliance: ApplianceModel): ApplianceModel =>
  appliance.beautyShotImageUrl || appliance.imageUrl
    ? appliance
    : {
        ...appliance,
        beautyShotImageUrl: IMAGE_COMING_SOON,
        imageUrl: IMAGE_COMING_SOON,
      };
